import _ from 'lodash';

import store from '../../../store';
import { OVERVIEW_PANEL_HIDE } from '../../../store/modules/overview-panel/types';
import environment from '../../environment';
import { isLayerEnabled } from '../../shared';
import { notify, NOTIFY_TYPE } from '../../shared/notify';
import templates from '../templates';
import googleAnalytics from '../tools/googleanalytics';
import { translate } from '../tools/translate';
import api from '../../api';
import { VehicleTypeEnum } from '../vehicleType/constants';
import { destroyIntercom, openIntercom } from '../../../helpers/intercom.helper';
import { SidebarButton } from '../sidebar/button.helper';
import { hidePanelSelectionAlert } from '../../../utils';
import { InfoMenuDot } from '../../shared/InfoMenuDot';
import databoard from '../databoard';
import Storage from '../../storage';
import { Network } from '../../../enuns/AfterSales/network';

const dialog = () => require('../dialog').default;
const sidebar = () => require('../sidebar').default;
const world = () => require('../map').default;
const compare = () => require('../map/compare').default;
const LayerInfo = name => require('../../info').get(name);
const LayerControls = (name) => require('../../controls').get(name);
const StoresAfterSalesLayer = () => require('../../layers/AfterSales/StoresAfterSalesLayer').default;

const infoBoard = (() => {
    return {
        locked: false,
        _triggerEvent: false,
        _activeItem: null,
        _context: null,
        _contextActions: {},

        _init() {
            const isAfterSales = environment.get('CONFIG.IS_AFTER_SALES');
            if (!isAfterSales) {
                Storage.save('infoboardOpen', true);
            }

            const inforboardState = Storage.get('infoboardOpen');
            if (inforboardState === null) {
                Storage.save('infoboardOpen', true);
            }

            if (!this._triggerEvent) {
                this.visible = false;
                this._triggerEvent = true;
                return this._initEvents();
            }
        },

        _initEvents() {
            this._setControlsProperties();

            $('#infoboard-tabs').on('click', function (e) {
                e.preventDefault();
                return $(this)
                    .find('li')
                    .removeClass('active');
            });

            $('#infoboard-tabs').on('click', 'li', e => {
                e.preventDefault();
                const target = e.target.id.replace(/-link/, '');

                this._context = target;
                if (this._contextActions[target]) {
                    $('#infoboard-actions').show();
                } else {
                    $('#infoboard-actions').hide();
                }

                return $('#infoboard-tabs-button').html(`${$(e.target).text()} <i class="fa fa-caret-down"></i>`);
            });

            $('#infoboard-actions')
                .find('a')
                .on('click', e => {
                    return this._actionContextTrigger(this.getCurrentContext(), $(e.target).data('target'));
                });

            return $(this.options.trigger).on('click touchstart', ev => {
                ev.preventDefault();
                this.toggleStateInfoboard();
                return this.toggle();
            });
        },

        _setControlsProperties() {
            this.ControlActions = (() => {
                const texts = {
                    locate: {
                        text: translate('Action.Locate'),
                        value: 'locate'
                    },
                    edit: {
                        text: translate('Action.Edit'),
                        value: 'edit'
                    },
                    remove: {
                        text: translate('Action.Remove'),
                        value: 'remove'
                    },
                    reporting: {
                        text: translate('Action.Report'),
                        value: 'reporting'
                    },
                    recalculate: {
                        text: translate('Action.RecalculateServiceArea'),
                        value: 'recalculate'
                    }
                };

                return key => {
                    return texts[key];
                };
            })();

            this.ControlButtons = (() => {
                const _iconTitle = {
                    actions: {
                        title: translate('Action.ShowOptions'),
                        display: true,
                        icon: 'fa-gear',
                        order: 1
                    },
                    summary: {
                        title: translate('Action.ShowMarketSummary'),
                        display: true,
                        icon: 'fa-info-circle',
                        order: 3
                    },
                    charts: {
                        title: translate('Action.ShowCharts'),
                        display: true,
                        icon: 'fa-bar-chart-o',
                        order: 4
                    },
                    trash: {
                        title: translate('Action.Remove'),
                        display: true,
                        icon: 'fa-trash-o',
                        order: 5
                    },
                    editPointOfInterest: {
                        title: translate('Action.EditPointOfInterest'),
                        display: true,
                        icon: 'fa-pencil',
                        order: 6
                    },
                    delPointOfInterest: {
                        title: translate('Action.RemovePointOfInterest'),
                        display: true,
                        icon: 'fa-trash-o',
                        order: 7
                    },
                    createInfluenceArea: {
                        title: translate('Action.CreateInfluenceArea'),
                        display: true,
                        icon: 'fa-plus',
                        order: 8
                    },
                    updateInfluenceArea: {
                        title: translate('Action.UpdateInfluenceArea'),
                        display: true,
                        icon: 'fa-pencil',
                        order: 9
                    },
                    removeInfluenceArea: {
                        title: translate('Action.RemoveInfluenceArea'),
                        display: true,
                        icon: 'fa-trash-o',
                        order: 10
                    },
                    hideStore: {
                        title: translate('Action.HideStore'),
                        display: true,
                        icon: 'fa-eye fa-eye-slash',
                        order: 11
                    },
                    edit: {
                        title: translate('Action.Edit'),
                        display: true,
                        icon: 'fa-edit',
                        order: 12
                    },
                    plus: {
                        title: translate('Action.Add'),
                        display: true,
                        icon: 'fa-plus',
                        order: 13
                    },
                    dashboardServiceArea: {
                        title: `${translate('Action.Show')} ${translate('Common.Indicators')}`,
                        display: true,
                        icon: 'fa-table',
                        order: 14
                    },
                    info: {
                        title: translate('Action.ShowInformation'),
                        display: false,
                        icon: 'fa-home',
                        order: 9999
                    },
                };

                return (name, key, id) => {
                    const idObj = {
                        id: `${name}-${key}-${id}`,
                        action_name: key
                    };
                    return _.assign({}, idObj, _iconTitle[key]);
                };
            })();
        },

        _swapIcons() {
            const button = $(this.options.trigger).find('i');
            button.toggleClass('fa-chevron-left fa-chevron-right');
        },

        // close sub menus
        _openMenu() {
            this._swapIcons();

            if (sidebar().isOpen() && Number($(window).width()) <= 1280) {
                sidebar().close();
            }

            this.visible = true;
            this._updateMapContainer();

            if (window.Intercom) {
                destroyIntercom();

                setTimeout(() => openIntercom(372, window.intercomSettings.vertical_padding), 100);
            }
        },
        // close sub menus
        _closeMenu() {

            this._swapIcons();

            if (sidebar().isOpen() && Number($(window).width()) <= 1280) {
                sidebar().close();
            }

            this.visible = false;
            this._updateMapContainer();

            if (window.Intercom) {
                destroyIntercom();
                setTimeout(() => openIntercom(20, window.intercomSettings.vertical_padding), 100);
            }
        },

        _setTransform(val, el) {
            return $(el).velocity({ translateX: val });
        },

        _updateMapContainer() {
            $('#main-pane').toggleClass('infoboard-open', this.visible);

            setTimeout(() => {
                world().refresh();
                if (compare().visible()) {
                    world()
                        .get(1)
                        .invalidateSize();
                }
            }, 400);
        },

        _setMapSize(size, side = 'bottom') {
            world()
                .get()
                .eachMap(m =>
                    $(m.getContainer()).velocity(
                        {
                            [side]: size
                        },
                        {
                            complete() {
                                world().refresh();
                            }
                        }
                    )
                );
        },

        _addActionBar(container, direction, callback) {
            if (container.find('.action-bar').length === 1) {
                return;
            }

            const footer = $(templates('shared-action-bar', { close: true }));
            $(container).append(footer);

            return $(footer)
                .find('.action-cancel')
                .on('click', function () {
                    if (callback) {
                        callback();
                    }

                    return container.velocity(
                        'fadeOut',
                        { duration: 500 },
                        {
                            complete() {
                                container.empty();
                            }
                        }
                    );
                });
        },

        _actionContextTrigger(context, action) {
            const $el = $(`#${context}`).find('[name="selected-location"]');

            if (_.size($el)) {
                if (action === 'select_all') {
                    return $el.each((i, el) => $(el).iCheck('check'));
                } else if (action === 'select_inverse') {
                    return $el.each((i, el) => $(el).iCheck('toggle'));
                } else {
                    return $el.each((i, el) => $(el).iCheck('uncheck'));
                }
            }
        },

        toggleStateInfoboard() {
            if (environment.get('CONFIG.IS_AFTER_SALES') === true) {
                const currentStateInfoboard = Storage.get('infoboardOpen') === true;
                const newState = !currentStateInfoboard;
                Storage.save('infoboardOpen', newState);
            }
        },

        setOptions(container, options) {
            this.options = options;
            this.wrapper = container;

            return this._init();
        },

        getCurrentContext() {
            return this._context;
        },

        open() {
            const currentStateInfoboard = Storage.get('infoboardOpen') === true;
            if (!this.visible && currentStateInfoboard) {
                return this._openMenu();
            }
        },

        toggle() {
            const currentStateInfoboard = Storage.get('infoboardOpen') === true;
            if (!this.visible && currentStateInfoboard) {
                return this._openMenu();
            } else {
                return this._closeMenu();
            }
        },

        close() {
            if (this.visible) {
                return this._closeMenu();
            }
        },

        showInfo(layer, id) {
            $(`#${layer.toLowerCase()}-tab-link`).trigger('click');
        },

        append(html) {
            return $(this.container).append(html);
        },

        createContainer(options = {}) {
            const id = `${options.id}-tab`;
            const name =
                options.name ||
                id
                    .replace('-tab', '')
                    .replace('-', ' ')
                    .toCapitalCase();

            const $wrapper = $(document.getElementById(options.wrapper) || this.wrapper);
            if ($wrapper.is(':hidden')) {
                $wrapper.show();
            }

            let $container = $(`#${id}`);
            if (!_.size($container)) {
                $container = $(`<div id="${id}" class="infoboard-tabs tab-pane"></div>`);
                if ($wrapper) {
                    $wrapper.append($container);
                    $wrapper.closest('.btn-group').on('click', function () {
                        return $(this)
                            .find('.active')
                            .removeClass('active');
                    });
                }
            }

            if (!_.size($(`#${id}-link`))) {
                $('#infoboard-tabs').append(`<li><a id="${id}-link" href="#${id}" data-toggle="tab">${name}</a></li>`);
            }

            if (options.visible) {
                $(`#${id}-link`).trigger('click');
            }

            if (options.actions) {
                this._contextActions[id] = true;
                if (this._context === id) {
                    $('#infoboard-actions').show();
                }
            }

            $container.empty();
            return $container;
        },

        isOpen() {
            return this.visible;
        },

        createTitle(title, container = null) {
            title = this._getTemplate('title', title);
            if (container) {
                return $(container).append(title);
            } else {
                return title;
            }
        },

        updateInputLabel(input) {
            const label = $(input)
                .parent()
                .find('label');
            if ($(input).val().length > 0) {
                if (label.length > 0) {
                    label.fadeIn();
                }

                $(this).attr('placeholder', '');
            } else {
                label.fadeOut();
                $(this).attr('placeholder', label.text());
            }
        },

        toggleDataboard(show = false, size = '50%', direction = 'down', name = '#databoard-container') {
            const $container = $(name);
            $container.css({ height: size });
            this._setMapSize(size);
            this.toggleContainer($container, direction, show);
            if ($container.find('.action-bar').length === 0) {
                this._addActionBar($container, direction, () => {
                    this._setMapSize(0);
                    store.dispatch(OVERVIEW_PANEL_HIDE);
                    databoard.setOpen(false);

                    SidebarButton.removeActiveButton('overview');
                });
            }
            databoard.setOpen(show);
        },

        toggleDashboard(show = false, direction = 'right') {
            const container = $('#dash-container');
            this.toggleContainer(container, direction, show);
            if (container.find('.action-bar').length === 0) {
                this._addActionBar(container, direction);
            }
        },

        toggleFilter(show = false, direction = 'up') {
            const $container = $('#filter-container');

            if (show) {
                this._setMapSize(104, 'top');
            } else {
                this._setMapSize(53, 'top');
                SidebarButton.removeActiveButton('filter');
            }

            this.toggleContainer($container, direction, show);
        },

        toggleContainer(container, direction = 'right', show = false) {
            if (show) {
                container.velocity('fadeIn', { duration: 500 });
            } else {
                container.velocity('fadeOut', { duration: 500 });
            }
        },

        toggleContext(options) {
            if (options) {
                if (_.isFunction(options.tab) && _.size(options.tab())) {
                    const el = `#${options
                        .tab()
                        .attr('id')
                        .replace('-link', '')}`;
                    if (isLayerEnabled(options.name)) {
                        this.dataUnavailable({
                            features: null,
                            container: el,
                            isEnabled: true
                        });
                        options.tab().trigger('click');
                    } else {
                        this.dataUnavailable({
                            features: null,
                            container: el,
                            isEnabled: false
                        });
                    }
                }
            }
        },

        dataUnavailable(options) {
            if (!options.message) {
                if (options.isEnabled) {
                    if (options.features && options.features.length >= 1000) {
                        options.message = 'Selecione uma área menor para visualização dos dados';
                    } else {
                        options.message = 'Não há dados neste nível de zoom ou área';
                    }
                } else {
                    options.message = translate('Error.LayerDisabled');
                }
            }

            if (!options.image) {
                options.image = options.isEnabled ? 'no_data' : 'no_actived';
            }

            if (!options.isEnabled || !options.features) {
                this.addMessage(options.container, options.message, options.image);
                return true;
            } else {
                if (options.features.length === 0 || options.features.length >= 800) {
                    this.addMessage(options.container, options.message, options.image);
                    if (!this.visible && options.isEnabled && options.features.length > 0) {
                        notify(NOTIFY_TYPE.LOG, options.message);
                    }

                    return true;
                }
            }

            return false;
        },

        addMessage(container, message, image = 'no_data') {
            const template = $(
                templates('shared-message', {
                    host: environment.get('IMAGES_HOST'),
                    image,
                    text: message
                })
            );
            $(container).html(template);
            $(container)
                .find('.ballon-container')
                .fadeIn();
        },

        createActions(options, context) {
            const actions = {
                export: false,
                compare: false,
                viewEvents: false,
                addEvents: false,
                editEvents: false,
                layout: $()
            };

            actions.layout = $(this._getTemplate('subactions'));

            const appendAction = (key, icon, name) => {
                const template = $(
                    this._getTemplate('subaction', {
                        icon,
                        text: options[key].label || name
                    })
                );
                template.appendTo(actions.layout);
                actions[key] = template;
                actions[key].on('click', e => {
                    googleAnalytics.trackEventGA('Infoboard', key, context);
                    e.preventDefault();
                });
            };

            if (options.export && options.export.value) {
                appendAction('export', 'fa-download', translate('Action.Export'));
            }

            if (options.compare && options.compare.value) {
                appendAction('compare', 'fa-check-square-o', translate('Action.Compare'));
            }

            if (options.report && options.report.value) {
                appendAction('report', 'fa-book', translate('Action.ShowReport'));
            }

            if (options.viewEvents && options.viewEvents.value) {
                appendAction('viewEvents', 'fa-list-alt', translate('Action.ShowEvents'));
            }

            if (options.addEvents && options.addEvents.value) {
                appendAction('addEvents', 'fa-table', translate('Action.AddEvents'));
            }

            if (options.editEvents && options.editEvents.value) {
                appendAction('editEvents', 'fa-file-excel-o', translate('Action.EditEvents'));
            }

            return actions;
        },

        enableCompare(container, resultType) {
            // display checkbox on panels
            $(container)
                .find('.panel-title')
                .each((i, el) => $(el).velocity({ width: '84%' }));

            // add compare buttons
            LayerInfo('Compare').setStatus(true);
            LayerInfo('Compare').show(container, resultType);
        },

        enableSelection(container, feature) {
            // display checkbox on panels
            $(container)
                .find('.panel-title')
                .each((i, el) => $(el).velocity({ width: '84%' }));

            // add compare buttons
            if (_.isFunction(LayerInfo(feature).set)) {
                LayerInfo(feature).set(true);
            }
            if (_.isFunction(LayerInfo(feature).show)) {
                LayerInfo(feature).show(container);
            }
        },

        createItem(options) {
            if ($(`#${options.name}-title-${options.feature.properties.Id}`).length !== 0) {
                return;
            }

            const self = this;

            const item = {
                btn: {},
                feature: options.feature,
                index: options.index,
            };

            const vehicleType = environment.get('CONFIG.USERVEHICLETYPE');
            let pathImage = vehicleType === VehicleTypeEnum.Moto || options.originalName === 'StoresMotocycle' ? '/motos' : '';
            const icon = null;
            let logo = null;

            if (environment.get('CONFIG.IS_AFTER_SALES') === true) {
                pathImage = '/aftersales';
            }

            if (options.name === "dealershipaftersales") {
                pathImage = '';
            }

            if (item.feature.properties['Bandeira'] || item.feature.properties['BrandName']) {
                let img = String(item.feature.properties['Bandeira']).toUnderscoreCase();
                if (img === "undefined") {
                    img = String(item.feature.properties['BrandName']).toUnderscoreCase();
                }
                logo = {
                    image: `logo_${img}`,
                    title: 'Logo da bandeira'
                };
            }

            if (options.originalName === 'StoresConsortium' && item.feature.properties['Tipo']) {
                logo = {
                    image: `logo_${String(item.feature.properties['Tipo']).toUnderscoreCase()}`,
                    title: 'Logo da bandeira'
                };
            }

            if (options.name === "unapprovedstores") {
                logo = {
                    image: 'logo_atention',
                    title: 'Logo da Rede não homologada'
                };
            }

            if (options.name === 'storeplanned') {
                logo = {
                    image: 'logo_lojas_previstas',
                    title: 'Logo das lojas planejadas'
                };
            }

            if (item.feature.properties['PinName']) {
                logo = {
                    image: `logo_${StoresAfterSalesLayer().getPinBaseName(options.originalName, item.feature.properties)}`,
                    title: 'Logo da rede'
                };
            }

            if (item.feature.properties['ScoreMax']) {
                logo = {
                    image: `../pin_pi_${String(item.feature.properties['Color'])}`,
                    title: 'Logo do pin'
                };
            }

            if (item.feature.properties['IsPinTire']) {
                logo = {
                    image: `logo_pneus`,
                    title: 'Logo da rede'
                };
            }

            let subheader;
            if (item.feature.properties['Endereco']) {
                subheader = item.feature.properties['Endereco'];
            } else if (item.feature.properties['Address']) {
                subheader = item.feature.properties['Address'];
            } else if (item.feature.properties['Tipo']) {
                subheader = item.feature.properties['Tipo'];
            } else if (item.feature.properties['Logradouro']) {
                subheader = item.feature.properties['Logradouro'];
            } else if (item.feature.properties['AddressComplement']) {
                subheader = item.feature.properties['AddressComplement'];
            } else {
                subheader = 'Localidade';
            }

            const template = {
                host: `${environment.get('IMAGES_HOST')}${pathImage}`,
                container: {
                    id: item.feature.properties.Id,
                    name: options.name
                },
                panel: {
                    title: item.feature.properties['Nome'] || item.feature.properties['Name'] || item.feature.properties['PointName'],
                    text: item.feature.properties['Nome'] || item.feature.properties['Name'] || item.feature.properties['PointName'],
                    subtext: subheader,
                    class: !(logo || icon) ? 'no-icons' : ''
                },
                icon,
                logo,
                checkbox: null,
                actions: null,
                controls: [],
                tabs: []
            };

            const compareSelection = ['compare', 'selection'];
            template.controls = Object.keys(options.controls)
                .filter(k => !compareSelection.contains(k) && options.controls[k])
                .map(k => this.ControlButtons(options.name, k, item.feature.properties.Id))
                .sort((a, b) => a.order - b.order);

            template.controls.onlyInfo = template.controls.every(x => !x.display);

            let checked;
            if (options.controls.selection) {
                checked = !!(options.check && options.check(item.feature.properties.Id));
                template.checkbox = {
                    id: `${options.name}-selection-${item.feature.properties.Id}`,
                    name: 'selected-location',
                    title: translate('Action.Select_1'),
                    checked
                };
            } else if (options.controls.compare) {
                checked = !!(compare && LayerInfo('Compare').check(item.feature.properties.Id));
                template.checkbox = {
                    id: `${options.name}-compare-${item.feature.properties.Id}`,
                    name: 'compare',
                    title: 'Comparar',
                    checked
                };
            }

            item.layout = $(templates('infoboard-list-item', template));
            item.title = item.layout.find(`#${options.name}-title-${item.feature.properties.Id}`);

            if (_.size(options.controls.actions) > 0) {
                item.btn.actions = item.layout.find(`#button-${options.name}-actions-${item.feature.properties.Id}`);
                item.btn.actions.on('click', e => {
                    e.preventDefault();
                    const values = Object.keys(options.controls.actions)
                        .filter(k => options.controls.actions[k] && k !== 'callback')
                        .map(k => this.ControlActions(k));

                    dialog().select(values, options.controls.actions.callback);
                });
            }

            if (options.controls.summary) {
                item.btn.summary = item.layout.find(`#button-${options.name}-summary-${item.feature.properties.Id}`);
                item.summary = item.layout.find(`#${options.name}-summary-${item.feature.properties.Id}`);
            }

            if (options.controls.info) {
                item.btn.info = item.layout.find(`#button-${options.name}-info-${item.feature.properties.Id}`);
                item.info = item.layout.find(`#${options.name}-info-${item.feature.properties.Id}`);
                item.image = item.layout.find('.store-thumbnail');

                item.btn.info.hide();
            }

            if (options.controls.plus) {
                item.btn.plus = item.layout.find(`#button-${options.name}-plus-${item.feature.properties.Id}`);
            }

            if (options.controls.charts) {
                item.btn.chart = item.layout.find(`#button-${options.name}-charts-${item.feature.properties.Id}`);
                item.chart = item.layout.find(`#${options.name}-charts-${item.feature.properties.Id}`);
            }

            if (options.controls.trash) {
                item.btn.trash = item.layout.find(`#button-${options.name}-trash-${item.feature.properties.Id}`);
            }

            if (options.controls.hideStore) {
                item.btn.hideStore = item.layout.find(`#button-${options.name}-hideStore-${item.feature.properties.Id}`);

                item.btn.hideStore.on('click', function (e) {
                    api.general.log.action(environment._getContextEnum(options.name), 'Info - Mostrar/Ocultar', JSON.stringify(options.feature.properties));
                    e.preventDefault();
                    $(this)
                        .parent()
                        .find('i')
                        .toggleClass('fa-eye fa-eye-slash');
                });
            }

            if (options.controls.dashboardServiceArea) {
                const $btn = item.layout.find(
                    `#button-${options.name}-dashboardServiceArea-${item.feature.properties.Id}`
                );

                if (item.feature.properties.NetworkId !== Network.Distributor) {
                    $btn.closest('div').hide();
                }

                if (item.feature.properties.NetworkId === Network.Distributor) {
                    item.btn.dashboardServiceArea = $btn;
                }
            }

            if (options.controls.createInfluenceArea) {
                item.btn.createInfluenceArea = item.layout.find(`#button-${options.name}-createInfluenceArea-${item.feature.properties.Id}`);
            }

            if (options.controls.updateInfluenceArea) {
                item.btn.updateInfluenceArea = item.layout.find(`#button-${options.name}-updateInfluenceArea-${item.feature.properties.Id}`);
            }

            if (options.controls.removeInfluenceArea) {
                item.btn.removeInfluenceArea = item.layout.find(`#button-${options.name}-removeInfluenceArea-${item.feature.properties.Id}`);
            }

            if (options.controls.editPointOfInterest) {
                item.btn.editPointOfInterest = item.layout.find(`#button-${options.name}-editPointOfInterest-${item.feature.properties.Id}`);
            }

            if (options.controls.delPointOfInterest) {
                item.btn.delPointOfInterest = item.layout.find(`#button-${options.name}-delPointOfInterest-${item.feature.properties.Id}`);
            }

            if (options.controls.edit) {
                item.btn.edit = item.layout.find(`#button-${options.name}-edit-${item.feature.properties.Id}`);
            }

            if (options.controls.compare) {
                item.btn.compare = item.layout.find(`#button-${options.name}-compare-${item.feature.properties.Id}`);
                item.btn.compare.iCheck({
                    checkboxClass: 'icheckbox_square-blue icheckbox_square-blue-info',
                    radioClass: 'iradio_square-blue',
                    increaseArea: '20%'
                });

                item.btn.compare.on('ifChecked', () => {
                    return LayerInfo('Compare').add(item.feature);
                });
                item.btn.compare.on('ifUnchecked', () => {
                    return LayerInfo('Compare').remove(item.feature);
                });
            }

            if (options.controls.selection) {
                item.btn.selection = item.layout.find(`#${options.name}-selection-${item.feature.properties.Id}`);
                item.btn.selection.iCheck({
                    checkboxClass: 'icheckbox_square-blue icheckbox_square-blue-info',
                    radioClass: 'iradio_square-blue',
                    increaseArea: '20%'
                });
            }

            _(item.btn)
                .filter(el => item.btn[el])
                .forEach(el =>
                    item.btn[el].on('click', e => {
                        e.preventDefault();
                        googleAnalytics.trackEventGA(
                            'Infoboard',
                            $(e.target).data('action'),
                            options.name,
                            item.feature.properties.Id
                        );
                    })
                );

            item.title.on('select', function () {
                hidePanelSelectionAlert();

                self.scrollTo(this, options.container);
                this.isOpen = true;

                $(this).addClass('panel-selection-alert');
            });

            item.title.on('click', function () {
                if (item.btn.info) {
                    item.btn.info.trigger('click');
                }
            });

            const onHover = (type) => {
                const layerControl = LayerControls(options.originalName);
                const layer = layerControl.getLayer();

                if (!layer.layer._map || !layer.layer._map._layers) {
                    return;
                }

                const markers = Object.keys(layer.layer._map._layers)
                    .map(x => layer.layer._map._layers[x]);

                const pins =
                    markers
                        .filter(x => x.feature)
                        .filter(x => x.feature.properties.Id === item.feature.properties.Id);

                if (pins.length) {
                    const marker = pins[0];

                    if (type === 'select') {
                        layerControl.select(marker, 'hover');
                        return;
                    }

                    layerControl.unselect(marker, 'hover');
                    return;
                }

                markers.forEach(x => {
                    if (x.getAllChildMarkers) {
                        const pinsInCluster = x.getAllChildMarkers()
                            .filter(y => y.feature)
                            .filter(y => y.feature.properties.Id === item.feature.properties.Id);

                        if (pinsInCluster.length) {

                            if (type === 'select') {
                                layerControl.select(x, 'hover');
                                return;
                            }

                            layerControl.unselect(x, 'hover');
                            return;
                        }
                    }
                });
            };

            if (!options.controls.selection) {
                item.title.on('mouseover', () => onHover('select'));
                item.title.on('mouseout', () => onHover('unselect'));
            }


            InfoMenuDot.create(item.title);

            return item;
        },

        scrollTo(target, container) {
            //    $(target).closest('.panel-default').velocity("scroll",
            //      container: $(container).find(".panel-group")
            //      delay: 1000
            //    )
            setTimeout(
                () =>
                    $(container)
                        .find('.panel-group')
                        .mCustomScrollbar('scrollTo', $(target).closest('.panel-default')),
                700
            );
        },

        _getTemplate(type, value) {
            switch (type) {
                case 'title':
                    return `<div class="infoboard-title">${value}</div>`;
                case 'subactions':
                    return '<div class="btn-group btn-group-justified panel-context"></div>';
                case 'subaction':
                    return `<a class="btn btn-link" data-target="#"><i class="fa fa-2x ${value.icon}"></i><span>${value.text
                        }</span></a>`;
            }
        }
    };
})();

export default infoBoard;



// WEBPACK FOOTER //
// ./src/scripts/core/infoboard/index.js